<h2 *ngIf="!modalData?.transaction?.timeSheetTransactionId && !modalData.timeSheetStatusError" mat-dialog-title>
	Add Transaction
</h2>
<h2 *ngIf="modalData?.transaction?.timeSheetTransactionId && !modalData.timeSheetStatusError" mat-dialog-title>
	Edit Transaction
</h2>
<h2 *ngIf="modalData.timeSheetStatusError" mat-dialog-title>Transaction</h2>

<mat-error *ngIf="errorMessage">{{ errorMessage }}</mat-error>

<div *ngIf="modalData.timeSheetStatusError && !modalData?.timeSheetLockOutError">
	<mat-error>{{ modalData.timeSheetStatusError }}</mat-error>
</div>

<div *ngIf="modalData.timeSheetLockOutError">
	<mat-error>{{ modalData.timeSheetLockOutError }}</mat-error>
</div>

<br />
<form [formGroup]="form">
	<mat-dialog-content>
		<div layout-gt-xs="row">
			<mat-form-field class="input-full-width">
				<input
					matInput
					[matDatepicker]="transactionDate"
					[min]="minDateValue"
					[max]="maxDateValue"
					formControlName="transactionDate"
					placeholder="Choose a date"
				/>
				<mat-datepicker-toggle matSuffix [for]="transactionDate"> </mat-datepicker-toggle>
				<mat-datepicker [touchUi]="modalData.isMobile" #transactionDate></mat-datepicker>
			</mat-form-field>
		</div>

		<div fxLayout="row" fxLayoutAlign="start center">
			<mat-form-field style="width: 100%;">
				<mat-select
					id="pay-category"
					name="pay-category"
					required
					placeholder="Pay category"
					formControlName="payCategoryId"
					(selectionChange)="onPayCategoryChange()"
				>
					<mat-option *ngFor="let item of activePayCategories" [value]="item.payCategoryId">
						{{ item.name }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>

		<div *ngIf="selectedPayCategory" layout-gt-xs="row">
			<mat-form-field class="input-full-width" *ngIf="selectedPayCategory?.unit !== 'Hours'">
				<!-- // Hours, Count, Dollars, Days, -->
				<input
					*ngIf="selectedPayCategory?.unit == 'Count' || selectedPayCategory?.unit == 'Days'"
					matInput
					required
					numberOnly="negativeNumbers"
					type="text"
					placeholder="{{ selectedPayCategory?.unit }}"
					formControlName="value"
				/>
				<input
					*ngIf="selectedPayCategory?.unit == 'Dollars' && selectedPayCategory?.unit !== 'Days'"
					matInput
					required
					decimalOnly="twoDigitDecimalNumber"
					type="text"
					placeholder="{{ selectedPayCategory?.unit }}"
					formControlName="value"
				/>
			</mat-form-field>
			<div *ngIf="selectedPayCategory?.unit === 'Hours'" style="display:flex; gap:1rem; width:30%">
				<mat-form-field style="width:30%">
					<input
						matInput
						required
						numberOnly="positiveNumbers"
						type="number"
						placeholder="Hours"
						formControlName="value"
						min="0"
					/>
				</mat-form-field>
				<mat-label class="mt-1">hour(s)</mat-label>
				<mat-form-field style="width:30%">
					<input
						matInput
						numberOnly="positiveNumbers"
						type="number"
						placeholder="Minutes *"
						formControlName="valueMinutes"
						max="59"
						min="0"
					/>
				</mat-form-field>
				<mat-label class="mt-1">minute(s)</mat-label>
			</div>
		</div>

		<div
			layout-gt-xs="row"
			formArrayName="timeSheetTransactionNoteValue"
			*ngFor="let item of form.get('timeSheetTransactionNoteValue')['controls']; let i = index"
		>
			<div [formGroupName]="i">
				<mat-form-field *ngIf="selectedPayCategory.notes[i].fieldType === 'PickList'" class="input-full-width">
					<mat-select
						[id]="'NOTE_PICK_LIST_ITEM_' + i"
						formControlName="value"
						[attr.required]="
							selectedPayCategory.notes[i].isRequired ? selectedPayCategory.notes[i].isRequired : null
						"
						[placeholder]="
							selectedPayCategory.notes[i].isRequired
								? selectedPayCategory.notes[i].name + ' *'
								: selectedPayCategory.notes[i].name
						"
					>
						<mat-option *ngFor="let item of selectedPayCategory.notes[i].pickListItems" [value]="item">
							{{ item }}
						</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field
					*ngIf="selectedPayCategory.notes[i].fieldType === 'AutoComplete'"
					class="input-full-width"
				>
					<input
						type="text"
						matInput
						formControlName="value"
						autocomplete="off"
						[id]="'NOTE_AUTOCOMPLETE_ITEM_' + i"
						[name]="'NOTE_AUTOCOMPLETE_ITEM_' + i"
						[matAutocomplete]="auto"
						[attr.required]="
							selectedPayCategory.notes[i].isRequired ? selectedPayCategory.notes[i].isRequired : null
						"
						[placeholder]="
							selectedPayCategory.notes[i].isRequired
								? selectedPayCategory.notes[i].name + ' *'
								: selectedPayCategory.notes[i].name
						"
					/>
					<mat-autocomplete #auto="matAutocomplete">
						<mat-option
							*ngFor="let option of selectedPayCategory.notes[i].autoCompleteItems"
							[value]="option"
						>
							{{ option }}
						</mat-option>
					</mat-autocomplete>
				</mat-form-field>
				<mat-form-field *ngIf="selectedPayCategory.notes[i].fieldType === 'FreeText'" class="input-full-width">
					<input
						formControlName="value"
						matInput
						[attr.required]="
							selectedPayCategory.notes[i].isRequired ? selectedPayCategory.notes[i].isRequired : null
						"
						[placeholder]="
							selectedPayCategory.notes[i].isRequired
								? selectedPayCategory.notes[i].name + ' *'
								: selectedPayCategory.notes[i].name
						"
					/>
				</mat-form-field>
			</div>
		</div>

		<div layout-gt-xs="row">
			<mat-form-field class="input-full-width">
				<input matInput placeholder="Comments" formControlName="comments" />
			</mat-form-field>
			<mat-error *ngIf="this.form.get('comments').hasError('required')">
				Comment is required
			</mat-error>
		</div>
	</mat-dialog-content>

	<mat-dialog-actions
		fxLayoutAlign="end end"
		*ngIf="modalData && !modalData.timeSheetStatusError && !modalData.timeSheetLockOutError"
	>
		<button class="mat-raised-button" (click)="close()" [disabled]="isSubmitted">
			Close
		</button>

		<button
			*ngIf="modalData && modalData?.transaction?.timeSheetTransactionNoteValues"
			color="warn"
			mat-button
			class="mat-raised-button"
			[disabled]="isSubmitted"
			(click)="deleteTransaction()"
		>
			Delete
		</button>

		<button class="mat-raised-button mat-primary" (click)="save()" [disabled]="isSubmitted">
			Save
		</button>
	</mat-dialog-actions>

	<div
		*ngIf="
			(modalData?.timeSheetStatusError && !modalData?.timeSheetLockOutError) || modalData?.timeSheetLockOutError
		"
	>
		<mat-dialog-actions fxLayoutAlign="end end">
			<button class="mat-raised-button" (click)="close()">Close</button>
		</mat-dialog-actions>
	</div>
</form>
